// THIS FILE IS AUTO-GENERATED. DO NOT EDIT. Re-run --exportTsApi to regenerate.
import { GroundTruthJobStatus } from "./GroundTruthJobStatus.gen";
import { TargetTypes } from "./Shared.TargetTypes.gen";

export interface IGroundTruthTrialResult {
	runId: string | undefined;

	status: GroundTruthJobStatus;

	totalCount: number | undefined;

	countsByType: { [key: string]: number } | undefined;

	targetFilter: TargetTypes | number ;

	errorMessage: string | undefined;

	$type?: string | undefined;
}
export class GroundTruthTrialResult {
	constructor(data?: IGroundTruthTrialResult) {
		if (!data) return;
		if (data.$type && data.$type !== this.$type) console.warn('The $type of data being parsed does not match the type of the object being created (' + this.$type + ')');
		Object.assign(this, data);
	}

	runId: string | undefined;

	status: GroundTruthJobStatus = 0;

	totalCount: number | undefined;

	countsByType: { [key: string]: number } | undefined;

	targetFilter: TargetTypes | number  = 0;

	errorMessage: string | undefined;

	static $type: string = "CoreApi.Models.GroundTruthTrialResult, ";
	$type?: string | undefined = GroundTruthTrialResult.$type;
}

